export enum RoomType {
	LobbyRoom = "lobby-room",
	GameRoom = "game-room",
}
